module.exports = __webpack_public_path__ + "img/chanpzs.1a2f0f6c.1a2f0f6c.png";